<template>
  <div style="min-height: 750px;" v-if="d_usrShpcrtBundWdm && d_usrShpcrtBundProWdm && d_usrShpcrtBundProPayWdm">
    <b-row>
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8"></b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>
    <b-row style="margin-bottom: 20px; border-bottom: solid 1px whitesmoke;">
      <b-col sm="12" md="2" lg="2"> </b-col>
      <b-col sm="12" md="4" lg="4">
        <i class="fa fa-desktop"></i>
        {{ StoreLangTranslation.data['active_products'][StoreLang] }}
        <i class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('research_methodology_and_article_management', StoreLang)"> </i>
      </b-col>
      <b-col sm="12" md="4" lg="4" :style="StoreDevice.isMobile ? '' : 'text-align: right;'"></b-col>
      <b-col sm="12" md="2" lg="2"></b-col>
    </b-row>

    <b-row style="font-size: 16px;">
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8">
       <b-card no-body>
        <b-card-header header-bg-variant="white" class="p-1">
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="6" style="padding: 2px;">
              <strong> {{ StoreLangTranslation.data['results'][StoreLang] }} </strong>
            </b-col>
            <b-col sm="12" lg="6" style="text-align: right;"></b-col>
          </b-row>
        </b-card-header>
          <template v-if="d_loading">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </template>
          <template v-else>
            <b-row>
              <b-col sm="12" lg="12">
                <!--
                  d_shopOrderList = [
                    {
                      "product_list": [],
                      "user_shopcart_bundle_data": {},
                      "user_shop_bundle_data": {},
                    }
                  ]
                 -->
                 <b-card no-body v-for="(shop_item, shop_item_index) in d_shopOrderList">
                  <!-- {{ shop_item }} -->
                  <b-card-header header-bg-variant="white" class="p-1">
                     <b-row class="bundle-title-box-style" style="margin: 0px; background-color: #; padding: 5px;">
                      <b-col sm="12" lg="4">
                          <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['2'] && shop_item.shop_data.data['0']['2']['lang'] && shop_item.shop_data.data['0']['2']['lang'][StoreLang]">
                            <img :src="shop_item.shop_data.data['0']['2']['lang'][StoreLang]" style="width: 30px; margin-right: 3px;">
                          </template>
                          <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['2'] && shop_item.shop_data.data['0']['2']['val']">
                            <img :src="shop_item.shop_data.data['0']['2']['val']" style="width: 30px; margin-right: 3px;">
                          </template>
                          <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['1'] && shop_item.shop_data.data['0']['1']['lang'] && shop_item.shop_data.data['0']['1']['lang'][StoreLang]">
                            <strong :title="shop_item.shop_data.data['0']['1']['lang'][StoreLang]">{{ shop_item.shop_data.data['0']['1']['lang'][StoreLang].length > 30 ? shop_item.shop_data.data['0']['1']['lang'][StoreLang].substring(0,15) + '...' : shop_item.shop_data.data['0']['1']['lang'][StoreLang] }}</strong>
                          </template>

                          <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['1'] && shop_item.shop_data.data['0']['1']['val']">
                            <strong :title="shop_item.shop_data.data['0']['1']['val']">{{ shop_item.shop_data.data['0']['1']['val'].length > 30 ? shop_item.shop_data.data['0']['1']['val'].substring(0,15) + '...' : shop_item.shop_data.data['0']['1']['val'] }}</strong>
                          </template>
                      </b-col>
                      <b-col sm="12" lg="2">
                        <i class="fa fa-envelope"></i>
                          <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['29'] && shop_item.shop_data.data['0']['29']['lang'] && shop_item.shop_data.data['0']['29']['lang'][StoreLang]">
                            <!-- <strong>{{ shop_item.shop_data.data['0']['29']['lang'][StoreLang] }}</strong> -->
                            <a :href="'mailto:' + shop_item.shop_data.data['0']['29']['lang'][StoreLang]">
                              <strong>{{ shop_item.shop_data.data['0']['29']['lang'][StoreLang] }}</strong>
                            </a>
                          </template>
                          <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['29'] && shop_item.shop_data.data['0']['29']['val']">
                            <!-- <strong>{{ shop_item.shop_data.data['0']['29']['val'] }}</strong> -->
                            <a :href="'mailto:' + shop_item.shop_data.data['0']['29']['val']">
                              <strong>{{ shop_item.shop_data.data['0']['29']['val'] }}</strong>
                            </a>
                          </template>

                      </b-col>
                      <b-col sm="12" lg="2">
                        <i class="fa fa-mobile-phone"></i>
                          <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['30'] && shop_item.shop_data.data['0']['30']['lang'] && shop_item.shop_data.data['0']['30']['lang'][StoreLang]">
                            <strong>{{ shop_item.shop_data.data['0']['30']['lang'][StoreLang] }}</strong>
                          </template>
                          <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['30'] && shop_item.shop_data.data['0']['30']['val']">
                            <strong>{{ shop_item.shop_data.data['0']['30']['val'] }}</strong>
                          </template>
                      </b-col>
                    </b-row>
                  </b-card-header>
                  <b-card-body>
                    <template v-for="(bundle_item, bundle_item_index) in shop_item.bundle_list" v-if="f_searchUserShopBundle(bundle_item)">
                       <b-row @mouseover="d_hoverIndex = bundle_item_index" @mouseleave="d_hoverIndex = ''" :style="StoreDevice.isMobile ? 'cursor: pointer; border-bottom: solid 1px #dcdcdc; font-weight: 900; background: #f7e48f;' : 'cursor: pointer; margin: 1px; border-bottom: solid 1px #dcdcdc; font-weight: 900; background: #f7e48f;'">
                        <b-col sm="12" lg="8">
                          <template v-if="bundle_item.user_shop_bundle_data.data && bundle_item.user_shop_bundle_data.data['0'] && bundle_item.user_shop_bundle_data.data['0']['1'] && bundle_item.user_shop_bundle_data.data['0']['1']['lang'] && bundle_item.user_shop_bundle_data.data['0']['1']['lang'][StoreLang]">
                            <span :style="d_hoverIndex === bundle_item_index ? ' color: rgb(252, 0, 153, 1);' : ''">{{ bundle_item.user_shop_bundle_data.data['0']['1']['lang'][StoreLang] }}</span>
                          </template>
                          <template v-else-if="bundle_item.user_shop_bundle_data.data && bundle_item.user_shop_bundle_data.data['0'] && bundle_item.user_shop_bundle_data.data['0']['1'] && bundle_item.user_shop_bundle_data.data['0']['1']['val']">
                            <span :style="d_hoverIndex === bundle_item_index ? ' color: rgb(252, 0, 153, 1);' : ''">{{ bundle_item.user_shop_bundle_data.data['0']['1']['val'] }}</span>
                          </template>
                        </b-col>
                        <b-col sm="12" lg="2">
                          {{ f_calculateProductTotalPrice(bundle_item.product_list) }}
                        </b-col>
                        <b-col sm="12" lg="2">
                            <template v-if="bundle_item.user_shopcart_bundle_data.data['0']['0'] && bundle_item.user_shopcart_bundle_data.data['0']['0']['val'] && bundle_item.user_shopcart_bundle_data.data['0']['0']['val']['value']">
                              {{ f_getOptionLabel(bundle_item.user_shopcart_bundle_data.data['0']['0']['val']['value'], d_usrShpcrtBundWdm['0']['parameters']['0']['options']) }}
                            </template>
                        </b-col>
                      </b-row>
                      <template v-for="(product_item, product_item_index) in bundle_item.product_list" v-if="f_showCheckProduct(product_item.product)">
                        <b-row :style="StoreDevice.isMobile ? 'cursor: pointer; border-bottom: solid 1px #dcdcdc; margin-left: 10px;' : 'cursor: pointer; margin: 1px; border-bottom: solid 1px #dcdcdc; margin-left: 10px;'">
                          <b-col sm="12" lg="6">
                            <i @click="f_openProductIngredients(product_item.product)" style="border-radius: 10px; padding-right: 5px; margin: 3px; padding-left: 5px; width: 20px; background-color: lightblue; text-align: center;">{{ (product_item_index + 1).toString() }}</i>
                            <template v-if="product_item.product.data && product_item.product.data['0'] && product_item.product.data['0']['1'] && product_item.product.data['0']['1']['lang'] && product_item.product.data['0']['1']['lang'][StoreLang]">
                              <span>{{ product_item.product.data['0']['1']['lang'][StoreLang] }}</span>
                            </template>
                            <template v-else-if="product_item.product.data && product_item.product.data['0'] && product_item.product.data['0']['1'] && product_item.product.data['0']['1']['val']">
                              <span>{{ product_item.product.data['0']['1']['val'] }}</span>
                            </template>
                          </b-col>
                          <b-col sm="12" lg="2"> {{ f_calculateProductTotalPrice([product_item]) }} </b-col>
                          <b-col sm="12" lg="2">
                            <template v-if="product_item.product.data['0']['0'] && product_item.product.data['0']['0']['val'] && product_item.product.data['0']['0']['val']['value']">
                                  {{ f_getOptionLabel(product_item.product.data['0']['0']['val']['value'], d_usrShpcrtBundProWdm['0']['parameters']['0']['options']) }}

                              </template>
                          </b-col>
                          <b-col sm="12" lg="2">
                            <b-dropdown variant="white" size="sm" style="width: 100%; float: left;">
                              <template slot="button-content">
                                <i class="fa fa-list-alt"></i>
                              </template>
                              <template v-if="product_item.product.data && product_item.product.data['0'] && product_item.product.data['0']['54'] && product_item.product.data['0']['54']['val'] && product_item.product.data['0']['54']['val']['value'] === '4'">
                                <template v-if="product_item.product.data && product_item.product.data['0'] && product_item.product.data['0']['55'] && product_item.product.data['0']['55']['val']">
                                  <template v-if="product_item.product.data && product_item.product.data['0'] && product_item.product.data['0']['56'] && product_item.product.data['0']['56']['val']">
                                    <b-dropdown-item @click="f_goToUserStatisticsViewProducts(bundle_item.user_shopcart_bundle_data.client_id, product_item.product.client_id, product_item.product.data['0']['55']['lang'][StoreLang], product_item.product.data['0']['56']['lang'][StoreLang])"><i class="fa fa-area-chart"></i> {{ StoreLangTranslation.data['statistics_result_view'][StoreLang] }} </b-dropdown-item>
                                  </template>
                                </template>
                              </template>
                              <template v-if="product_item.product.data && product_item.product.data['0'] && product_item.product.data['0']['54'] && product_item.product.data['0']['54']['val'] && product_item.product.data['0']['54']['val']['value'] === '5'">
                                <template v-if="product_item.product.data && product_item.product.data['0'] && product_item.product.data['0']['55'] && product_item.product.data['0']['55']['val']">
                                  <b-dropdown-item @click="f_goToUserDatasetFilterProducts(bundle_item.user_shopcart_bundle_data.client_id, product_item.product.client_id, product_item.product.data['0']['55']['lang'][StoreLang])"><i class="fa fa-pie-chart"></i> {{ StoreLangTranslation.data['dataset_filter'][StoreLang] }} </b-dropdown-item>
                                </template>
                              </template>
                              <template v-if="product_item.product.data && product_item.product.data['0'] && product_item.product.data['0']['54'] && product_item.product.data['0']['54']['val'] && product_item.product.data['0']['54']['val']['value'] === '6'">
                                <template v-if="product_item.product.data && product_item.product.data['0'] && product_item.product.data['0']['55'] && product_item.product.data['0']['55']['val']">
                                  <b-dropdown-item @click="f_goToUserDatasetStatisticsQueryProducts(bundle_item.user_shopcart_bundle_data.client_id, product_item.product.client_id, product_item.product.data['0']['55']['lang'][StoreLang])"><i class="fa fa-pie-chart"></i> {{ StoreLangTranslation.data['dataset_stats_query'][StoreLang] }} </b-dropdown-item>
                                </template>
                              </template>
                              <template v-if="product_item.product.data && product_item.product.data['0'] && product_item.product.data['0']['54'] && product_item.product.data['0']['54']['val'] && product_item.product.data['0']['54']['val']['value'] === '7'">
                                <template v-if="product_item.product.data && product_item.product.data['0'] && product_item.product.data['0']['55'] && product_item.product.data['0']['55']['val'] && product_item.product.data['0']['57'] && product_item.product.data['0']['57']['val']">
                                  <b-dropdown-item @click="f_goToUserMachineLearningQueryProducts(bundle_item.user_shopcart_bundle_data.client_id, product_item.product.client_id, product_item.product.data['0']['55']['lang'][StoreLang], product_item.product.data['0']['57']['lang'][StoreLang])"><i class="fa fa-pie-chart"></i> {{ StoreLangTranslation.data['machine_learning_query'][StoreLang] }} </b-dropdown-item>
                                </template>
                              </template>
                              <template v-if="bundle_item.user_shop_bundle_data.data && bundle_item.user_shop_bundle_data.data['0'] && bundle_item.user_shop_bundle_data.data['0']['56'] && bundle_item.user_shop_bundle_data.data['0']['56']['val'] && bundle_item.user_shop_bundle_data.data['0']['56']['val']['value'] && bundle_item.user_shop_bundle_data.data['0']['56']['val']['value'] === '1'">
                                <b-dropdown-item @click="f_copyDataAvailabilityStatement(shop_item.shop_data, bundle_item.user_shop_bundle_data.id, 'en')"><i class="fa fa-clone"></i> {{ StoreLangTranslation.data['copy_data_availability_statement_en'][StoreLang] }} </b-dropdown-item>
                                <b-dropdown-item @click="f_copyDataAvailabilityStatement(shop_item.shop_data, bundle_item.user_shop_bundle_data.id, 'tr')"><i class="fa fa-clone"></i> {{ StoreLangTranslation.data['copy_data_availability_statement_tr'][StoreLang] }} </b-dropdown-item>
                                <b-dropdown-item @click="f_openArticleModal(shop_item.shop_data, bundle_item.user_shop_bundle_data)"><i class="fa fa-flask"></i> {{ StoreLangTranslation.data['research_methodology_and_article_management'][StoreLang] }} </b-dropdown-item>
                              </template>
                            </b-dropdown>
                          </b-col>
                        </b-row>
                        <!-- {{ bundle_item.user_shop_bundle_data.data['0'] }} -->
                        <template v-for="(payment_item, payment_index) in product_item.payment_list">
                            <b-row :style="StoreDevice.isMobile ? 'cursor: pointer; border-bottom: solid 1px #dcdcdc; margin-left: 30px; font-size: 12px;' : 'cursor: pointer; margin: 1px; border-bottom: solid 1px #dcdcdc; margin-left: 30px; font-size: 12px;'">
                            <b-col sm="12" lg="1" style="padding: 2px; text-align: right;">
                              <i @click="f_openProductPaymentIngredients(payment_item)" style="border-radius: 10px; padding-right: 5px; margin: 3px; padding-left: 5px; width: 20px; background-color: #ade6ad; text-align: center;">{{ (payment_index + 1).toString() }}</i>
                            </b-col>
                            <b-col sm="12" lg="1" style="padding: 2px;">
                              <template v-if="payment_item.data['0']['1'] && payment_item.data['0']['1']['val'] && payment_item.data['0']['1']['val']['value']">
                                {{ f_getOptionLabel(payment_item.data['0']['1']['val']['value'], d_usrShpcrtBundProPayWdm['0']['parameters']['1']['options']) }}
                              </template>
                            </b-col>
                            <b-col sm="12" lg="2" style="padding: 2px;">
                              <template v-if="payment_item.data['0']['2'] && payment_item.data['0']['2']['val'] && payment_item.data['0']['2']['val']['value']">
                                {{ f_getOptionLabel(payment_item.data['0']['2']['val']['value'], d_usrShpcrtBundProPayWdm['0']['parameters']['2']['options']) }}
                              </template>
                            </b-col>
                            <b-col sm="12" lg="1" style="padding: 2px;">
                              <template v-if="payment_item.data['0']['4'] && payment_item.data['0']['4']['val']">
                                {{ payment_item.data['0']['4']['val'] }}
                              </template>
                              <template v-if="payment_item.data['0']['3'] && payment_item.data['0']['3']['val'] && payment_item.data['0']['3']['val']['value']">
                                {{ f_getOptionLabel(payment_item.data['0']['3']['val']['value'], d_usrShpcrtBundProPayWdm['0']['parameters']['3']['options']) }}
                              </template>
                            </b-col>
                            <b-col sm="12" lg="2">
                              <template v-if="payment_item.data['0']['17'] && payment_item.data['0']['17']['val']">
                                {{ payment_item.data['0']['17']['val'] }}
                              </template>
                            </b-col>
                            <b-col sm="12" lg="2">
                              <template v-if="payment_item.data['0']['0'] && payment_item.data['0']['0']['val'] && payment_item.data['0']['0']['val']['value']">
                                <span style="font-size: 12px;"> {{ f_getOptionLabel(payment_item.data['0']['0']['val']['value'], d_usrShpcrtBundProPayWdm['0']['parameters']['0']['options']) }} </span>
                              </template>
                            </b-col>
                          </b-row>
                        </template>
                        <template v-if="d_authProductList[product_item.product.client_id]">
                          <b-row style="margin: 3px;">
                            <b-col sm="12" lg="12">
                              {{ StoreLangTranslation.data['used_usage'][StoreLang] }} {{ d_authProductList[product_item.product.client_id]['used_auth_count'] }} / {{ d_authProductList[product_item.product.client_id]['auth_count'] }}
                            </b-col>
                          </b-row>
                        </template>
                      </template>
                      

                      <template v-if="d_userShopBundleWdm && bundle_item.user_shop_bundle_data.data['0']['56'] && bundle_item.user_shop_bundle_data.data['0']['56']['val'] && bundle_item.user_shop_bundle_data.data['0']['56']['val']['value'] && bundle_item.user_shop_bundle_data.data['0']['56']['val']['value'] == '1'">
                        <b-card-header v-if="f_valValueCheck(bundle_item.user_shop_bundle_data.data['0'], ['39', '38', '36', '37'], ['46', '35'])" header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                          <b-row>
                            <b-col sm="12" lg="8">
                              <h6>
                                <i class="fa fa-calculator"></i>
                                {{ StoreLangTranslation.data['dataset_features'][StoreLang] }}
                              </h6>
                            </b-col>
                            <b-col sm="12" lg="4" style="text-align: right;"></b-col>
                          </b-row>
                        </b-card-header>
                        <b-card-body>
                          <b-row v-if="bundle_item.user_shop_bundle_data.data['0']['39'] && bundle_item.user_shop_bundle_data.data['0']['39']['val']" class="dataset-item-row-style">
                            <b-col sm="12" lg="12">
                              <i class="fa fa-angle-double-right product-icon-style"></i>
                              <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['39']['name']['translation'][StoreLang] }}</strong><br/>
                              <div class="text-color-dark-gray" v-html="bundle_item.user_shop_bundle_data.data['0']['39']['lang'][StoreLang]"></div>
                            </b-col>
                          </b-row>
                          <b-row v-if="bundle_item.user_shop_bundle_data.data['0']['46'] && bundle_item.user_shop_bundle_data.data['0']['46']['val'] && bundle_item.user_shop_bundle_data.data['0']['46']['val']['value']" class="dataset-item-row-style">
                            <b-col sm="12" lg="12">
                              <i class="fa fa-angle-double-right product-icon-style"></i>
                              <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['46']['name']['translation'][StoreLang] }}</strong><br/>
                              <small class="text-color-dark-gray"> {{ bundle_item.user_shop_bundle_data.data['0']['46']['val']['translation'][StoreLang] }} </small>
                            </b-col>
                          </b-row>
                          <!-- <b-row v-if="bundle_item.user_shop_bundle_data.data['0']['38'] && bundle_item.user_shop_bundle_data.data['0']['38']['val']" class="dataset-item-row-style">
                            <b-col sm="12" lg="12">
                              <i class="fa fa-angle-double-right product-icon-style"></i>
                              <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['38']['name']['translation'][StoreLang] }}</strong><br/>
                              <small class="text-color-dark-gray"> {{ bundle_item.user_shop_bundle_data.data['0']['38']['lang'][StoreLang] }} </small>
                            </b-col>
                          </b-row> -->
                          <b-row v-if="bundle_item.user_shop_bundle_data.data['0']['38'] && bundle_item.user_shop_bundle_data.data['0']['38']['val']" class="dataset-item-row-style">
                            <b-col sm="12" lg="12">
                              <i class="fa fa-angle-double-right product-icon-style"></i>
                              <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['38']['name']['translation'][StoreLang] }}</strong><br/>
                              <div class="text-color-dark-gray" v-html="bundle_item.user_shop_bundle_data.data['0']['38']['lang'][StoreLang]"></div>
                            </b-col>
                          </b-row>
                          <b-row v-if="bundle_item.user_shop_bundle_data.data['0']['35'] && bundle_item.user_shop_bundle_data.data['0']['35']['val'] && bundle_item.user_shop_bundle_data.data['0']['35']['val']['value']" class="dataset-item-row-style">
                            <b-col sm="12" lg="12">
                              <i class="fa fa-angle-double-right product-icon-style"></i>
                              <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['35']['name']['translation'][StoreLang] }}</strong><br/>
                              <small class="text-color-dark-gray"> {{ d_userShopBundleWdm['0']['parameters']['35'].options[bundle_item.user_shop_bundle_data.data['0']['35']['val']['value']].translation[StoreLang] }} </small>
                            </b-col>
                          </b-row>
                          <b-row v-if="bundle_item.user_shop_bundle_data.data['0']['36'] && bundle_item.user_shop_bundle_data.data['0']['36']['val']" class="dataset-item-row-style">
                            <b-col sm="12" lg="12">
                              <i class="fa fa-angle-double-right product-icon-style"></i>
                              <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['36']['name']['translation'][StoreLang] }}</strong><br/>
                              <small class="text-color-dark-gray"> {{ bundle_item.user_shop_bundle_data.data['0']['36']['val'] }} </small>
                            </b-col>
                          </b-row>
                          <b-row v-if="bundle_item.user_shop_bundle_data.data['0']['37'] && bundle_item.user_shop_bundle_data.data['0']['37']['val']" class="dataset-item-row-style">
                            <b-col sm="12" lg="12">
                              <i class="fa fa-angle-double-right product-icon-style"></i>
                              <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['37']['name']['translation'][StoreLang] }}</strong><br/>
                              <small class="text-color-dark-gray"> {{ bundle_item.user_shop_bundle_data.data['0']['37']['val'] }} </small>
                            </b-col>
                          </b-row>
                        </b-card-body>

                        <b-card-header v-if="f_valValueCheck(bundle_item.user_shop_bundle_data.data['0'], ['52', '42'], ['40', '41'])" header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                          <b-row>
                            <b-col sm="12" lg="8">
                              <h6>
                                <i class="fa fa-calculator"></i>
                                {{ StoreLangTranslation.data['dataset_subscriber_features'][StoreLang] }}
                              </h6>
                            </b-col>
                            <b-col sm="12" lg="4" style="text-align: right;"></b-col>
                          </b-row>
                        </b-card-header>
                        <b-card-body>
                          <b-row v-if="bundle_item.user_shop_bundle_data.data['0']['40'] && bundle_item.user_shop_bundle_data.data['0']['40']['val'] && bundle_item.user_shop_bundle_data.data['0']['40']['val']['value']" class="dataset-item-row-style">
                            <b-col sm="12" lg="12">
                              <i class="fa fa-angle-double-right product-icon-style"></i>
                              <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['40']['name']['translation'][StoreLang] }}</strong><br/>
                              <small class="text-color-dark-gray"> {{ bundle_item.user_shop_bundle_data.data['0']['40']['val']['translation'][StoreLang] }} </small>
                            </b-col>
                          </b-row>
                          <b-row v-if="bundle_item.user_shop_bundle_data.data['0']['52'] && bundle_item.user_shop_bundle_data.data['0']['52']['val']" class="dataset-item-row-style">
                            <b-col sm="12" lg="12">
                              <i class="fa fa-angle-double-right product-icon-style"></i>
                              <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['52']['name']['translation'][StoreLang] }}</strong><br/>
                              <small class="text-color-dark-gray"> {{ bundle_item.user_shop_bundle_data.data['0']['52']['lang'][StoreLang] }} </small>
                            </b-col>
                          </b-row>
                          <template v-if="bundle_item.user_shop_bundle_data.data['0']['41'] && bundle_item.user_shop_bundle_data.data['0']['41'].val && bundle_item.user_shop_bundle_data.data['0']['41'].val.value && bundle_item.user_shop_bundle_data.data['0']['41'].val.value == 1">
                            <b-row v-if="bundle_item.user_shop_bundle_data.data['0']['42'] && bundle_item.user_shop_bundle_data.data['0']['42']['val']" class="dataset-item-row-style">
                              <b-col sm="12" lg="12">
                                <i class="fa fa-angle-double-right product-icon-style"></i>
                                <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['42']['name']['translation'][StoreLang] }}</strong><br/>
                                <small class="text-color-dark-gray"> {{ bundle_item.user_shop_bundle_data.data['0']['42']['lang'][StoreLang] }} </small>
                              </b-col>
                            </b-row>
                          </template>
                        </b-card-body>

                        <b-card-header v-if="bundle_item.user_shop_bundle_data.data['0']['57'] && bundle_item.user_shop_bundle_data.data['0']['57']['list'] && bundle_item.user_shop_bundle_data.data['0']['57']['list'].length > 0" header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                          <b-row>
                            <b-col sm="12" lg="8">
                              <h6>
                                <i class="fa fa-calculator"></i>
                                {{ StoreLangTranslation.data['dataset_author_and_article_information'][StoreLang] }}
                              </h6>
                            </b-col>
                            <b-col sm="12" lg="4" style="text-align: right;"></b-col>
                          </b-row>
                        </b-card-header>
                        <b-card-body>
                          
                          <template v-if="bundle_item.user_shop_bundle_data.data['0']['57'] && bundle_item.user_shop_bundle_data.data['0']['57']['list'] && bundle_item.user_shop_bundle_data.data['0']['57']['list'].length > 0">
                            <b-row class="dataset-item-row-style">
                              <b-col sm="12" lg="12">
                                <i class="fa fa-angle-double-right product-icon-style"></i>
                                <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['57']['name']['translation'][StoreLang] }}</strong><br/>
                              </b-col>
                            </b-row>
                            <b-row v-for="(author_item, author_index) in bundle_item.user_shop_bundle_data.data['0']['57']['list']" class="dataset-item-row-style">
                              <b-col sm="12" lg="12">
                                {{author_index + 1 + ') '}}
                                <small v-if="author_item['60'] && author_item['60']['val']" class="text-color-dark-gray"> {{ author_item['60']['val'] }} </small>{{' '}}
                                <small v-if="author_item['58'] && author_item['58']['val']" class="text-color-dark-gray"> {{ author_item['58']['val'] }} </small>{{' '}}
                                <small v-if="author_item['59'] && author_item['59']['val']" class="text-color-dark-gray"> {{ author_item['59']['val'] }} </small>{{', '}}
                                <small v-if="author_item['62'] && author_item['62']['lang'] && author_item['62']['lang'][StoreLang]" class="text-color-dark-gray"> {{ author_item['62']['lang'][StoreLang] }} </small>
                                <a v-if="author_item['63'] && author_item['63']['val']" :href="'https://orcid.org/' + author_item['63']['val']" target="_blank">
                                  <img src="@/icon/orcid_id.png" style="width: 1.2em;">
                                </a>
                              </b-col>
                            </b-row>
                          </template>

                          <b-row v-if="bundle_item.user_shop_bundle_data.data['0']['43'] && bundle_item.user_shop_bundle_data.data['0']['43']['val']" class="dataset-item-row-style">
                            <b-col sm="12" lg="12">
                              <i class="fa fa-angle-double-right product-icon-style"></i>
                              <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['43']['name']['translation'][StoreLang] }}</strong><br/>
                              <small class="text-color-dark-gray"> {{ bundle_item.user_shop_bundle_data.data['0']['43']['lang'][StoreLang] }} </small>
                            </b-col>
                          </b-row>
                          <b-row v-if="bundle_item.user_shop_bundle_data.data['0']['44'] && bundle_item.user_shop_bundle_data.data['0']['44']['val']" class="dataset-item-row-style">
                            <b-col sm="12" lg="12">
                              <i class="fa fa-angle-double-right product-icon-style"></i>
                              <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['44']['name']['translation'][StoreLang] }}</strong><br/>
                              <small class="text-color-dark-gray"> {{ bundle_item.user_shop_bundle_data.data['0']['44']['val'] }} </small>
                            </b-col>
                          </b-row>
                          <b-row v-if="bundle_item.user_shop_bundle_data.data['0']['45'] && bundle_item.user_shop_bundle_data.data['0']['45']['val']" class="dataset-item-row-style">
                            <b-col sm="12" lg="12">
                              <i class="fa fa-angle-double-right product-icon-style"></i>
                              <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['45']['name']['translation'][StoreLang] }}</strong><br/>
                              <small class="text-color-dark-gray"> {{ bundle_item.user_shop_bundle_data.data['0']['45']['lang'][StoreLang] }} </small>
                            </b-col>
                          </b-row>



                          <template v-if="bundle_item.user_shop_bundle_data.data['0']['64'] && bundle_item.user_shop_bundle_data.data['0']['64']['list'] && bundle_item.user_shop_bundle_data.data['0']['64']['list'].length > 0">
                            <b-row class="dataset-item-row-style">
                              <b-col sm="12" lg="12">
                                <i class="fa fa-angle-double-right product-icon-style"></i>
                                <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['64']['name']['translation'][StoreLang] }}</strong><br/>
                              </b-col>
                            </b-row>

                            <b-row v-for="(article_item, article_index) in bundle_item.user_shop_bundle_data.data['0']['64']['list']" class="dataset-item-row-style">
                              <b-col sm="12" lg="12">
                                <template v-if="article_item['65'] && article_item['65']['val'] && article_item['65']['val']['value'] && article_item['65']['val']['value'] == '1'">
                                  <b-row v-if="article_item['49'] && article_item['49']['val']" class="dataset-item-row-style" style="background-color: #e1ecfb !important;">
                                    <b-col sm="12" lg="12">
                                      <small class="text-color-dark-gray"> {{ article_item['49']['val'] }} </small>
                                      <span v-if="article_item['50'] && article_item['50']['val']">
                                        <a :href="f_addUtmSource(article_item['50']['val'])" target="_blank">
                                          <i class="fa fa-link"></i>
                                        </a>
                                      </span>
                                      <span v-if="article_item['48'] && article_item['48']['val']">
                                        [
                                          {{ article_item['48']['val'] }}
                                        ]
                                      </span>
                                    </b-col>
                                  </b-row>
                                  
                                  <b-row class="dataset-item-row-style">
                                    <b-col sm="12" lg="12">
                                      <template v-if="article_item['66'] && article_item['66']['list'] && article_item['66']['list'].length > 0">
                                        <b-row v-for="(article_author_item, article_author_index) in article_item['66']['list']" class="dataset-item-row-style">
                                          <b-col sm="12" lg="12">
                                            {{article_author_index + 1 + ') '}}
                                            <small v-if="article_author_item['69'] && article_author_item['69']['val']" class="text-color-dark-gray"> {{ article_author_item['69']['val'] }} </small>{{' '}}
                                            <small v-if="article_author_item['67'] && article_author_item['67']['val']" class="text-color-dark-gray"> {{ article_author_item['67']['val'] }} </small>{{' '}}
                                            <small v-if="article_author_item['68'] && article_author_item['68']['val']" class="text-color-dark-gray"> {{ article_author_item['68']['val'] }} </small>{{', '}}
                                            <small v-if="article_author_item['71'] && article_author_item['71']['lang'] && article_author_item['71']['lang'][StoreLang]" class="text-color-dark-gray"> {{ article_author_item['71']['lang'][StoreLang] }} </small>
                                            <a v-if="article_author_item['72'] && article_author_item['72']['val']" :href="'https://orcid.org/' + article_author_item['72']['val']" target="_blank">
                                              <img src="@/icon/orcid_id.png" style="width: 1.2em;">
                                            </a>
                                          </b-col>
                                        </b-row>
                                      </template>
                                    </b-col>
                                  </b-row>
                                  
                                  <b-row v-if="article_item['73'] && article_item['73']['val']" class="dataset-item-row-style">
                                    <b-col sm="12" lg="12">
                                      <i class="fa fa-angle-double-right product-icon-style"></i>
                                      <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['73']['name']['translation'][StoreLang] }}</strong><br/>
                                      <small class="text-color-dark-gray"> {{ article_item['73']['val'] }} </small>
                                    </b-col>
                                  </b-row>
                                  
                                </template>
                              </b-col>
                            </b-row>
                          </template>
                        </b-card-body>


                        
                        <b-card-header v-if="f_valValueCheck(bundle_item.user_shop_bundle_data.data['0'], ['53', '54', '55'], [])" header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                          <b-row>
                            <b-col sm="12" lg="8">
                              <h6>
                                <i class="fa fa-calculator"></i>
                                {{ StoreLangTranslation.data['ethics_committee_information'][StoreLang] }}
                              </h6>
                            </b-col>
                            <b-col sm="12" lg="4" style="text-align: right;"></b-col>
                          </b-row>
                        </b-card-header>
                        <b-card-body>
                          <b-row v-if="bundle_item.user_shop_bundle_data.data['0']['53'] && bundle_item.user_shop_bundle_data.data['0']['53']['val']" class="dataset-item-row-style">
                            <b-col sm="12" lg="12">
                              <i class="fa fa-angle-double-right product-icon-style"></i>
                              <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['53']['name']['translation'][StoreLang] }}</strong><br/>
                              <small class="text-color-dark-gray"> {{ bundle_item.user_shop_bundle_data.data['0']['53']['lang'][StoreLang] }} </small>
                            </b-col>
                          </b-row>
                          <b-row v-if="bundle_item.user_shop_bundle_data.data['0']['54'] && bundle_item.user_shop_bundle_data.data['0']['54']['val']" class="dataset-item-row-style">
                            <b-col sm="12" lg="12">
                              <i class="fa fa-angle-double-right product-icon-style"></i>
                              <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['54']['name']['translation'][StoreLang] }}</strong><br/>
                              <small class="text-color-dark-gray"> {{ bundle_item.user_shop_bundle_data.data['0']['54']['val'] }} </small>
                            </b-col>
                          </b-row>
                          <b-row v-if="bundle_item.user_shop_bundle_data.data['0']['55'] && bundle_item.user_shop_bundle_data.data['0']['55']['val']" class="dataset-item-row-style">
                            <b-col sm="12" lg="12">
                              <i class="fa fa-angle-double-right product-icon-style"></i>
                              <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['55']['name']['translation'][StoreLang] }}</strong><br/>
                              <small class="text-color-dark-gray"> {{ bundle_item.user_shop_bundle_data.data['0']['55']['val'] }} </small>
                            </b-col>
                          </b-row>
                        </b-card-body>


                        
                        <b-card-header v-if="f_valValueCheck(bundle_item.user_shop_bundle_data.data['0'], ['30', '31', '32'], ['29'])" header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                          <b-row>
                            <b-col sm="12" lg="8">
                              <h6>
                                <i class="fa fa-calculator"></i>
                                {{ StoreLangTranslation.data['dataset_contact_information'][StoreLang] }}
                              </h6>
                            </b-col>
                            <b-col sm="12" lg="4" style="text-align: right;"></b-col>
                          </b-row>
                        </b-card-header>
                        <b-card-body>
                          <template v-if="bundle_item.user_shop_bundle_data.data['0']['29'] && bundle_item.user_shop_bundle_data.data['0']['29'].val && bundle_item.user_shop_bundle_data.data['0']['29'].val.value && bundle_item.user_shop_bundle_data.data['0']['29'].val.value == 1">
                            <b-row v-if="bundle_item.user_shop_bundle_data.data['0']['30'] && bundle_item.user_shop_bundle_data.data['0']['30']['val']" class="dataset-item-row-style">
                              <b-col sm="12" lg="12">
                                <i class="fa fa-angle-double-right product-icon-style"></i>
                                <strong class="dataset-label-style">{{ d_userShopBundleWdm['0']['parameters']['30']['name']['translation'][StoreLang] }}</strong><br/>
                                <small class="text-color-dark-gray"> {{ bundle_item.user_shop_bundle_data.data['0']['30']['val'] }} </small>
                              </b-col>
                            </b-row>
                            <b-row v-if="bundle_item.user_shop_bundle_data.data['0']['31'] && bundle_item.user_shop_bundle_data.data['0']['31']['val']" class="dataset-item-row-style">
                              <b-col sm="12" lg="12">
                                <i class="fa fa-angle-double-right product-icon-style"></i>
                                <strong class="dataset-label-style">{{ d_userShopBundleWdm['0']['parameters']['31']['name']['translation'][StoreLang] }}</strong><br/>
                                <small class="text-color-dark-gray"> {{ bundle_item.user_shop_bundle_data.data['0']['31']['val'] }} </small>
                              </b-col>
                            </b-row>
                            <b-row v-if="bundle_item.user_shop_bundle_data.data['0']['32'] && bundle_item.user_shop_bundle_data.data['0']['32']['val']" class="dataset-item-row-style">
                              <b-col sm="12" lg="12">
                                <i class="fa fa-angle-double-right product-icon-style"></i>
                                <strong class="dataset-label-style">{{ d_userShopBundleWdm['0']['parameters']['32']['name']['translation'][StoreLang] }}</strong><br/>
                                <small class="text-color-dark-gray"> {{ bundle_item.user_shop_bundle_data.data['0']['32']['lang'][StoreLang] }} </small>
                              </b-col>
                            </b-row>
                          </template>
                        </b-card-body>


                        

                      </template>

                      <div style="margin-bottom: 10px">
                        <b-row style="margin: 3px;">
                          <b-col sm="12" lg="6">
                            <!-- <span v-if="d_bundleDocLoading == bundle_item.user_shopcart_bundle_data.client_id"> -->
                            <span v-if="d_loading">
                              <b-spinner variant="primary" style="margin: 2px;"></b-spinner>
                            </span>
                            <span v-else-if="bundle_item.user_shopcart_bundle_data.data['0']['35'] && bundle_item.user_shopcart_bundle_data.data['0']['35']['val']" style="color: blue; cursor: pointer;" @click="f_startBundleDocumentDownload(bundle_item.user_shopcart_bundle_data.client_id)">
                              {{ StoreLangTranslation.data['download_receipt_document'][StoreLang] }}
                            </span>
                            <span v-else style="color: red">
                              {{ StoreLangTranslation.data['no_receipt_document'][StoreLang] }}
                            </span>
                          </b-col>
                          <!-- <b-col sm="12" lg="6">
                            <b-form-file
                              v-model="d_tmpFile"
                              :accept="f_createAcceptedDocumentTypes()"
                              @input="f_addFileToDocuments(bundle_item.user_shopcart_bundle_data.parent_c.id, bundle_item.user_shopcart_bundle_data.client_id, bundle_item)"
                              :browse-text="StoreLangTranslation.data['select_file'][StoreLang]"
                              :placeholder="StoreLangTranslation.data['select_receipt_file'][StoreLang]"
                              style="margin-bottom: 5px;"
                              :disabled="d_bundleDocLoading == bundle_item.user_shopcart_bundle_data.client_id"
                            ></b-form-file>
                          </b-col> -->
                          <b-col sm="12" lg="6">
                          </b-col>
                        </b-row>
                      </div>
                      <b-row style="text-align: right; border-radius: 10px 10px; background-color: rgb(0 255 206); margin: 3px; padding: 3px;">
                        <b-col cols="12">
                          <i class="fa fa-angle-right"></i>
                          <span style="cursor: pointer; color: royalblue;" @click="f_agrementView(bundle_item.user_shopcart_bundle_data.client_id, shop_item.shop_data.client_id)">
                            {{ StoreLangTranslation.data['click_for_agreement_preview'][StoreLang] }}
                          </span>
                        </b-col>
                      </b-row>
                    </template>
                  </b-card-body>
                 </b-card>
              </b-col>
            </b-row>
          </template>
          
      </b-card>

      </b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>
    
    <b-modal v-if="d_selectedProductData.show" id="d_selectedProductData_show" v-model="d_selectedProductData.show" scrollable hide-footer :title="StoreLangTranslation.data['product_ingredients'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="lg">
      <p>
        <b-row>
          <b-col sm="12" lg="12">
            <shopcard-bundle-product-show :p_productData="d_selectedProductData.data"></shopcard-bundle-product-show>
          </b-col>
        </b-row>
      </p>
      <p>
      <b-row>
          <b-col sm="12" lg="6"></b-col>
          <b-col sm="12" lg="6" style="text-align: right;">
          </b-col>
        </b-row>
      </p>
    </b-modal>
    <b-modal v-if="d_selectedProductPaymentData.show" id="d_selectedProductPaymentData_show" v-model="d_selectedProductPaymentData.show" scrollable hide-footer :title="StoreLangTranslation.data['payment_details'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="lg">
      <p>
        <b-row>
          <b-col sm="12" lg="12">
            <shopcard-bundle-product-payment-show :p_paymentData="d_selectedProductPaymentData.data"></shopcard-bundle-product-payment-show>
          </b-col>
        </b-row>
      </p>
      <p>
      <b-row>
          <b-col sm="12" lg="6"></b-col>
          <b-col sm="12" lg="6" style="text-align: right;">
          </b-col>
        </b-row>
      </p>
    </b-modal>
    <b-modal v-if="d_agreementModal.show" id="d_agreementModal_show" v-model="d_agreementModal.show" scrollable hide-footer :title="StoreLangTranslation.data['agreement_preview'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="xl">
      <p>
        <b-row>
          <b-col sm="12" lg="12">
            <agreement-view :p_shopData="d_agreementModal.shop_data" :p_bundleData="d_agreementModal.bundle_data" :p_showMode="{'mode': 'approve'}" :p_agreementFrom="'shopcart'"></agreement-view>
          </b-col>
        </b-row>
      </p>
    </b-modal>

    <b-modal v-if="d_showArticleModal" id="d_showArticleModal" v-model="d_showArticleModal" scrollable hide-footer :title="StoreLangTranslation.data['research_methodology_and_article_management'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="xl">
      <p>
        <b-row>
          <b-col sm="12" lg="4" style="border-right: 1px solid gray;">
            
            <b-button @click="f_addArticle()" variant="primary" style="width: 100%; margin-bottom: 10px;">
              {{ StoreLangTranslation.data['new_research_methodology_and_article_management'][StoreLang] }}
            </b-button>
            <b-row>
              <b-col sm="12" lg="3">
                <strong>{{ StoreLangTranslation.data['status'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="9">
                <strong>{{ StoreLangTranslation.data['title'][StoreLang] }}</strong>
              </b-col>
            </b-row>
            <hr/>
            <!-- {{ d_articleData }} -->
            <!-- <div v-for="(article, article_index) in d_selectedBundle.data['0']['64']['list']"> -->
            <template v-if="d_selectedBundle.data['0']['64'] && d_selectedBundle.data['0']['64']['list']">
              <div v-for="(article, article_index) in d_selectedBundle.data['0']['64']['list']
                .filter(a => a['74'] && a['74']['val'] && a['74']['val'] === d_user.username)"
                :key="article_index">
                <div v-if="(article['48'] && article['48']['val']) || (article['78'] && article['78']['val'])" @click="f_selectArticle(article, article_index)" :style="d_selectedArticleIndex === article_index ? 'background-color: cyan; cursor: pointer; border-bottom: 1px solid gray; padding: 10px 5px;' : 'cursor: pointer; border-bottom: 1px solid gray; padding: 10px 5px;'">
                  <b-row>
                    <b-col sm="12" lg="3">
                      <span v-if="article['65']" :style="article['65']['val']['value'] == '1' ? 'color: green;' : 'color: red;'">
                        <!-- {{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['65']['options'] }} -->
                        {{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['65']['options'][article['65']['val']['value']]['translation'][StoreLang] }}
                      </span>
                      <i v-if="article['65']['val']['value'] == '1'" class="fa fa-info-circle" style="color:#2492FF;margin-left:5px;" @click="$help('article_to_passive', StoreLang)"> </i>
                    </b-col>
                    <b-col sm="12" lg="9">
                      <template v-if="article['49'] && article['49']['val']">
                        {{article['49']['val']}} 
                        <small v-if="article['73'] && article['73']['val']">
                          [{{article['73']['val']}}]
                        </small>
                      </template>
                      <template v-else>
                        {{article['78']['val']}}
                      </template>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </template>
          </b-col>
          <b-col sm="12" lg="8" v-if="d_articleAdding">
            <template v-if="d_articleSaveLoading">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </template>
            <template v-else>
              <b-row style="margin: 3px;">
                <b-col sm="12" lg="4">
                  <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['48']['name']['translation'][StoreLang] }}</strong>
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-input
                    :disabled="d_articleActive"
                    class="form-control"
                    v-model="d_articleData.journal_name">
                  </b-form-input>
                </b-col>
              </b-row>

              <b-row style="margin: 3px;">
                <b-col sm="12" lg="4">
                  <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['49']['name']['translation'][StoreLang] }}</strong>
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-input
                    :disabled="d_articleActive"
                    class="form-control"
                    v-model="d_articleData.article_title">
                  </b-form-input>
                </b-col>
              </b-row>

              <b-row style="margin: 3px;">
                <b-col sm="12" lg="4">
                  <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['50']['name']['translation'][StoreLang] }}</strong>
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-input
                    :disabled="d_articleActive"
                    class="form-control"
                    v-model="d_articleData.article_link">
                  </b-form-input>
                </b-col>
              </b-row>

              <b-row style="margin: 3px;">
                <b-col sm="12" lg="4">
                  <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['73']['name']['translation'][StoreLang] }}</strong>
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-input
                    :disabled="d_articleActive"
                    class="form-control"
                    type="date"
                    v-model="d_articleData.article_date">
                  </b-form-input>
                </b-col>
              </b-row>

              <b-row style="margin: 3px;">
                <b-col sm="12" lg="4">
                  <!-- <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['78']['name']['translation'][StoreLang] }}</strong> -->
                  <strong>metodoloji</strong>
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-textarea
                    :disabled="d_articleActive"
                    class="form-control"
                    v-model="d_articleData.research_methodology">
                  </b-form-textarea>
                </b-col>
              </b-row>

              <b-row style="margin: 3px;">
                <b-col sm="12" lg="4">
                  <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['66']['name']['translation'][StoreLang] }}</strong>
                </b-col>
                <b-col sm="12" lg="8" v-if="!d_articleActive">
                  <button class="btn btn-success" @click="f_addArticleAuthor()">
                    +
                  </button>
                </b-col>
              </b-row>
              <b-row v-if="!d_articleActive" style="margin: 3px; margin-bottom: 10px;">
                <b-col sm="12" lg="4">
                  <strong>
                    {{ StoreLangTranslation.data['author_search_by_mail_and_add'][StoreLang] }}
                  </strong>
                </b-col>

                <b-col sm="12" lg="6">
                    <b-form-textarea type="text" v-model="d_searchAuthorMails" :placeholder="StoreLangTranslation.data['please_add_mails_with_commas'][StoreLang]"></b-form-textarea>
                </b-col>
                <b-col sm="12" lg="2">
                  <template v-if="d_authorSearchLoading">
                    <b-spinner variant="primary" label="Spinning"></b-spinner>
                  </template>
                  <template v-else>
                    <button class="btn btn-primary" @click="f_authorSearchByMailAndAdd(d_articleData.article_authors)">
                      <i class="fa fa-search-plus"></i>
                    </button>
                  </template>
                </b-col>
              </b-row>
              <b-row style="margin: 3px;">
                <b-col sm="12" lg="10">
                  <div v-for="(article_author_item, article_author_index) in d_articleData.article_authors" :key="'article_author_' + article_author_index">

                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="2">
                        <button v-if="!d_articleActive" class="btn btn-danger" @click="f_removeArticleAuthor(article_author_index)">
                          -
                        </button>
                      </b-col>
                      <b-col sm="12" lg="4">
                        <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['66']['parameters']['69']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="6">
                        <b-form-input
                          :disabled="d_articleActive"
                          class="form-control"
                          v-model="article_author_item.title">
                        </b-form-input>
                      </b-col>
                    </b-row>

                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="2">
                      </b-col>
                      <b-col sm="12" lg="4">
                        <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['66']['parameters']['67']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="6">
                        <b-form-input
                          :disabled="d_articleActive"
                          class="form-control"
                          v-model="article_author_item.firstname">
                        </b-form-input>
                      </b-col>
                    </b-row>

                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="2">
                      </b-col>
                      <b-col sm="12" lg="4">
                        <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['66']['parameters']['68']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="6">
                        <b-form-input
                          :disabled="d_articleActive"
                          class="form-control"
                          v-model="article_author_item.lastname">
                        </b-form-input>
                      </b-col>
                    </b-row>

                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="2">
                      </b-col>
                      <b-col sm="12" lg="4">
                        <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['66']['parameters']['70']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="6">
                        <b-form-input
                          :disabled="d_articleActive"
                          class="form-control"
                          v-model="article_author_item.mail">
                        </b-form-input>
                      </b-col>
                    </b-row>

                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="2">
                      </b-col>
                      <b-col sm="12" lg="4">
                        <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['66']['parameters']['71']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="6">
                        <b-form-input
                          :disabled="d_articleActive"
                          class="form-control"
                          v-model="article_author_item.institution">
                        </b-form-input>
                      </b-col>
                    </b-row>

                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="2">
                      </b-col>
                      <b-col sm="12" lg="4">
                        <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['66']['parameters']['72']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="6">
                        <b-form-input
                          :disabled="d_articleActive"
                          class="form-control"
                          v-model="article_author_item.orcid_id">
                        </b-form-input>
                      </b-col>
                    </b-row>

                    <b-row v-if="" style="margin: 3px;">
                      <b-col sm="12" lg="2">
                      </b-col>
                      <b-col sm="12" lg="10">
                        <hr/>
                      </b-col>
                    </b-row>
                  </div>

                </b-col>
              </b-row>

              <b-row v-if="" style="margin: 3px;">
                <b-col sm="12" lg="12">
                  <hr/>
                </b-col>
              </b-row>
              
              <b-button :disabled="d_articleActive" style="float: right;" variant="success" @click="f_saveArticle()">
                {{ StoreLangTranslation.data['save'][StoreLang] }}
              </b-button>
            </template>
          </b-col>
        </b-row>
      </p>
    </b-modal>
  </div>
</template>
<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsRoute } from '@/wam/modules/route';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as PageInfo
} from '@/components/widgets/PageInfo';
import {
  default as ShopcardBundleProductShow
} from '@/components/widgets/ShopcardBundleProductShow';
import {
  default as ShopcardBundleProductPaymentShow
} from '@/components/widgets/ShopcardBundleProductPaymentShow';
import {
  default as AgreementView
} from '@/wam/components/widgets/AgreementView';
import { mapGetters } from 'vuex';
export default {
  name: 'user_product_bundles_active',
  computed: mapGetters({
    StoreLang: 'StoreLang',
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
    StoreShopCartOrderList: 'StoreShopCartOrderList',
    StoreCurrencyType: 'StoreCurrencyType',
  }),
  components: {
    PageInfo,
    ShopcardBundleProductShow,
    ShopcardBundleProductPaymentShow,
    AgreementView,
  },
  props: {},
  data () {
    return {
      d_loading: false,
      d_selectedProductListForPayment: {
        'user_shopcart_bundle_client_id': '',
        'product_list': [],
        'show': false
      },
      d_selectedProductPaymentData: {
        'data': '',
        'show': false
      },
      d_selectedProductData: {
        'data': '',
        'show': false
      },
      d_paymentModal: {
        'data': '',
        'show': false
      },
      d_userShopBundleWdm: '',
      d_usrShpcrtBundWdm: '',
      d_usrShpcrtBundProWdm: '',
      d_usrShpcrtBundProPayWdm: '',
      d_currencyType: '0', // 0 tl, 1 dollar
      d_user: '',
      d_hoverIndex: '',
      d_searchText: '',
      d_frontendClientID: '',
      d_frontendList: [],
      d_usrShpBundleList: [],
      d_shopOrderList: [],
      d_agreementModal: {
        'show': false,
        'shop_data': {},
        'bundle_data': {},
      },
      d_articleList: [],
      d_selectedTab: 'article_list',
      d_selectedArticle: '',
      d_showArticleModal: false,
      d_selectedBundle: '',
      d_selectedArticleIndex: '',
      d_articleData: {
        'journal_name': '',
        'article_title': '',
        'article_link': '',
        'article_date': '',
        'research_methodology': '',
        'article_authors': [],
      },
      d_authorSearchLoading: false,
      d_searchAuthorMails: '',
      d_articleAdding: false,
      d_articleActive: false,
      d_articleSaveLoading: false,
      d_authProductList: {},
      d_userAuthorizationListLoading: false,
    };
  },
  created: function () {
    ClsWdm.getLayerWdm('usr_shp_bund').then(resp_wdm_data => { this.d_userShopBundleWdm = resp_wdm_data; });
    ClsWdm.getLayerWdm('usr_shpcrt_bund').then(resp_wdm_data => { this.d_usrShpcrtBundWdm = resp_wdm_data; });
    ClsWdm.getLayerWdm('usr_shpcrt_bund_pro').then(resp_wdm_data => { this.d_usrShpcrtBundProWdm = resp_wdm_data; });
    ClsWdm.getLayerWdm('usr_shpcrt_bund_pro_pay').then(resp_wdm_data => { this.d_usrShpcrtBundProPayWdm = resp_wdm_data; });
    this.d_user = JSON.parse(localStorage.getItem('user'));
    this.d_userShopClientID = this.$route.query.user_shop_client_id;
    this.f_userShopCartBundleActiveList();
    this.f_getUserAuthorizationList();
  },
  beforeMount () {},
  mounted: function () {
    // console.log(this.StoreFrontendSettings);
  },
  methods: {
    f_valValueCheck: function (search_data, val_variable_list, value_variable_list) {
      if (val_variable_list.length > 0) {
        for (let val_variable_item of val_variable_list) {
          let is_include = false;
          try {
            if (search_data[val_variable_item]['val']) {
              is_include = true;
            }
          } catch(err) {}
          if (is_include) {
            return true;
          }
        }
      }
      if (value_variable_list.length > 0) {
        for (let value_variable_item of value_variable_list) {
          let is_include = false;
          try {
            if (search_data[value_variable_item]['val']['value']) {
              is_include = true;
            }
          } catch(err) {}
          if (is_include) {
            return true;
          }
        }
      }
      return false;
    },
    f_addUtmSource: function (raw_link) {
      let link_with_utm = '';
      let x = raw_link.split('?');
      let fullHost = window.location.host;
      if (fullHost.startsWith("www.")) {
        fullHost = fullHost.replace("www.", "");
      }
      let domain = fullHost.split("/")[0];

      if (x.length == 1) {
        link_with_utm = x[0] + '?utm_source=' + domain;
      } else {
        link_with_utm = x[0] + '?utm_source=' + domain + '&' + x[1];
      }
      return link_with_utm;
    },
    f_getUserAuthorizationList: function () {
      this.d_userAuthorizationListLoading = true;
      let query = 'user_client_id=' + this.d_user.username;
      query += '&auth_status=active';
      let data = {};
      this.d_authProductList = {};
      ServiceFunctions.user_authorization_list(query, data)
        .then(resp => {
          this.d_userAuthorizationListLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            for (let i in resp.data.list) {
              let shopcart_bund_pro_id = '';
              try {
                shopcart_bund_pro_id = resp.data.list[i].auth_data.data['0']['10']['val'];
              } catch(err) {}

              let auth_count = '';
              try {
                auth_count = resp.data.list[i].auth_data.data['0']['6']['val'];
              } catch(err) {}

              let used_auth_count = '';
              try {
                used_auth_count = resp.data.list[i].auth_data.data['0']['7']['val'];
              } catch(err) {}
              
              if (shopcart_bund_pro_id && auth_count) {
                this.d_authProductList[shopcart_bund_pro_id] = {
                  'auth_count': auth_count,
                  'used_auth_count': '0'
                };
                if (used_auth_count) {
                  this.d_authProductList[shopcart_bund_pro_id]['used_auth_count'] = used_auth_count
                }
              }
            }
          } else {
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
          }
        });
    },
    f_saveArticle: function () {
      this.d_articleSaveLoading = true;
      let query = 'user_shop_bundle_client_id=' + this.d_selectedBundle.client_id;
      let data = {
        'article_data': this.d_articleData,
        'article_index': this.d_selectedArticleIndex,
      };
      ServiceFunctions.user_shop_bundle_article_record(query, data)
        .then(resp => {
          this.d_articleSaveLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {

            if (resp.data.bundle_wdmr) {
              for (let shop_item of this.d_shopOrderList) {
                for (let shop_bundle_item of shop_item.bundle_list) {
                  if (shop_bundle_item.user_shop_bundle_data.client_id == this.d_selectedBundle.client_id) {
                    shop_bundle_item.user_shop_bundle_data = resp.data.bundle_wdmr;
                    break;
                  }
                }
              }
              if (resp.data.new_article_index) {
                this.d_selectedArticleIndex = resp.data.new_article_index;
              }
            }
            this.d_selectedBundle = resp.data.bundle_wdmr

          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_authorSearchByMailAndAdd: function(insert_data){
      // console.log(this.d_selectedAgreementCopy);
      let query = 'user_shop_client_id=' + this.d_userShopClientID;
      query += '&user_client_id=' + this.d_user.username;
      let data = {
        'author_mails': this.d_searchAuthorMails.replace(' ', '').split(',')
      };
      this.d_authorSearchLoading = true;
      ServiceFunctions.user_shop_bundle_author_search(query, data)
        .then(resp => {
          this.d_authorSearchLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list && resp.data.list.length > 0) {
              for (let i in resp.data.list) {
                insert_data.push(resp.data.list[i]);
              }
              this.$forceUpdate();
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_selectArticle: function (article, article_index) {
      this.d_articleData = {
        'journal_name': '',
        'article_title': '',
        'article_link': '',
        'article_date': '',
        'research_methodology': '',
        'article_authors': [],
      };
      try {
        this.d_articleData.journal_name = article['48']['val']
      } catch {}
      try {
        this.d_articleData.article_title = article['49']['val']
      } catch {}
      try {
        this.d_articleData.article_link = article['50']['val']
      } catch {}
      try {
        this.d_articleData.article_date = article['73']['val']
      } catch {}
      try {
        this.d_articleData.research_methodology = article['78']['val']
      } catch {}
      for (let artcl_authr of article['66']['list']) {
        let new_author = {
          'firstname': "",
          'lastname': "",
          'title': "",
          'mail': "",
          'institution': "",
          'orcid_id': "",
        };
        try {
          new_author.firstname = artcl_authr['67']['val']
        } catch {}
        try {
          new_author.lastname = artcl_authr['68']['val']
        } catch {}
        try {
          new_author.title = artcl_authr['69']['val']
        } catch {}
        try {
          new_author.mail = artcl_authr['70']['val']
        } catch {}
        try {
          new_author.institution = artcl_authr['71']['val']
        } catch {}
        try {
          new_author.orcid_id = artcl_authr['72']['val']
        } catch {}
        this.d_articleData.article_authors.push(new_author);
      }
      this.d_selectedArticleIndex = article_index;
      this.d_articleAdding = true;
      if (article['65'] && article['65']['val']['value'] == '1') {
        this.d_articleActive = true;
      } else {
        this.d_articleActive = false;
      }
    },
    f_openArticleModal: function (shop_data, user_shop_bundle_data) {
      this.d_selectedBundle = user_shop_bundle_data;
      this.d_showArticleModal = true;
    },
    f_addArticleAuthor() {
      this.d_articleData.article_authors.push({
        'firstname': "",
        'lastname': "",
        'title': "",
        'mail': "",
        'institution': "",
        'orcid_id': "",
      });
    },
    f_removeArticleAuthor(article_author_index) {
      if (confirm(this.StoreLangTranslation.data['delete_confirm'][this.StoreLang])) {
        this.d_articleData.article_authors.splice(article_author_index, 1);
      }
    },
    f_addArticle() {
      this.d_selectedArticleIndex = '';
      this.d_articleData = {
        'journal_name': '',
        'article_title': '',
        'article_link': '',
        'article_date': '',
        'research_methodology': '',
        'article_authors': [],
      };
      this.d_articleAdding = true;
      this.d_articleActive = false;
    },
    f_startBundleDocumentDownload: function (user_shopcart_bundle_client_id) {
      let query = 'user_client_id=' + this.d_user.username;
      query += '&user_shopcart_bundle_client_id=' + user_shopcart_bundle_client_id;
      let data = {};
      ServiceFunctions.user_shopcart_bundle_document_get(query, data)
        .then(resp => {
          if (resp.data.doc && resp.data.doc_extension) {
            let file_name = 'receipt.' + resp.data.doc_extension;
            this.f_downloadDocument(resp.data.doc, file_name)
          } else {
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
          }
        });
    },
    f_downloadDocument: function (base64_file, base64_file_name) {
      // console.log("base64_file ", base64_file);
      // console.log("base64_file_name ", base64_file_name);
      function base64ToArrayBuffer(base64) {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
          var ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
        }
        return bytes;
      }

      var saveByteArray = (function () {
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        return function (data, name) {
          var blob = new Blob(data, { type: "octet/stream" }),
            url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = name;
          a.click();
          window.URL.revokeObjectURL(url);
        };
      }());
      var sampleBytes = base64ToArrayBuffer(base64_file);
      saveByteArray([sampleBytes], base64_file_name);
    },
    f_copyDataAvailabilityStatement: function (shop_data, bundle_id, language) {

      // The dataset generated and analyzed in this study is publicly available on the Istinye University Dataset Sharing Platform. Anonymized data can be accessed at the following link: https:/dataset.istinye.edu.tr/dataset?did=60. All data were fully anonymized in accordance with ethical regulations. Access is provided for research purposes through a controlled-access system under the platform’s standard licensing and data-sharing policies.

      // Bu çalışmada oluşturulan ve analiz edilen veri seti, İstinye Üniversitesi Veri Seti Paylaşım Platformu'nda kamuya açıktır. Anonimleştirilmiş verilere şu bağlantıdan erişilebilir: https:/dataset.istinye.edu.tr/dataset?did=60. Tüm veriler etik düzenlemelere uygun olarak tamamen anonimleştirilmiştir. Erişim, platformun standart lisanslama ve veri paylaşım politikaları kapsamında kontrollü erişim sistemi aracılığıyla araştırma amaçlı olarak sağlanmaktadır.

      const origin = window.location.origin;
      const didPath = '/dataset?did=' + bundle_id;
      const didUrl = origin + didPath;
      let shop_name = '';
      if (shop_data.data['0']['31'] && shop_data.data['0']['31']['val']) {
        shop_name = shop_data.data['0']['31']['lang'][language]
      } else {
        shop_name = shop_data.data['0']['1']['lang'][language]
      }
      let dataAvailabilityStatementText = ''
      if (language == 'en') {
        dataAvailabilityStatementText += 'The dataset generated and analyzed in this study is publicly available on the ' + shop_name + ' Dataset Sharing Platform. Anonymized data can be accessed at the following link: ' + didUrl + '. All data were fully anonymized in accordance with ethical regulations. Access is provided for research purposes through a controlled-access system under the platform’s standard licensing and data-sharing policies.'
      } else if (language == 'tr') {
        dataAvailabilityStatementText += 'Bu çalışmada oluşturulan ve analiz edilen veri seti, ' + shop_name + ' Veri Seti Paylaşım Platformu\'nda kamuya açıktır. Anonimleştirilmiş verilere şu bağlantıdan erişilebilir: ' + didUrl + '. Tüm veriler etik düzenlemelere uygun olarak tamamen anonimleştirilmiştir. Erişim, platformun standart lisanslama ve veri paylaşım politikaları kapsamında kontrollü erişim sistemi aracılığıyla araştırma amaçlı olarak sağlanmaktadır.'
      }
      // console.log(dataAvailabilityStatementText);

      navigator.clipboard.writeText(dataAvailabilityStatementText)
        .then(() => {
          this.$bvToast.toast(this.StoreLangTranslation.data['copied'][this.StoreLang], {
            title: 'Bilgi',
            variant: 'success',
            toaster: 'b-toaster-top-right',
            autoHideDelay: 2000,
            solid: true
          });
        })
        .catch(err => {
          this.$bvToast.toast(this.StoreLangTranslation.data['copy_error'][this.StoreLang], {
            title: 'Hata',
            variant: 'danger',
            toaster: 'b-toaster-top-right',
            autoHideDelay: 3000,
            solid: true
          });
          console.error(err);
        });

    },
    f_agrementView: function (user_shop_bundle_client_id, user_shop_client_id) {
      this.d_agreementModal.shop_data = {'client_id': user_shop_client_id };
      this.d_agreementModal.bundle_data = {'client_id': user_shop_bundle_client_id, 'agreement_client_id': '' };
      this.d_agreementModal.show = true;
    },
    f_goToUserDatasetFilterProducts: function (user_shopcart_bundle_client_id, user_shopcart_bundle_product_client_id, project_id) {
      this.$router.push({
        'path': ClsRoute.f_getRoutePath('user_project_dataset_filter', this.StoreLang),
        'query': {
          'project_id': project_id,
          'project_type': 'wanalyzer_dataset_filter',
        }
      });
    },
    f_goToUserDatasetStatisticsQueryProducts: function (user_shopcart_bundle_client_id, user_shopcart_bundle_product_client_id, project_id) {
      this.$router.push({
        'path': ClsRoute.f_getRoutePath('user_project_dataset_statistics_query', this.StoreLang),
        'query': {
          'project_id': project_id,
          'project_type': 'wanalyzer_dataset_stats_query',
        }
      });
    },
    f_goToUserMachineLearningQueryProducts: function (user_shopcart_bundle_client_id, user_shopcart_bundle_product_client_id, project_id, machine_learning_id) {
      this.$router.push({
        'path': ClsRoute.f_getRoutePath('user_project_machine_learning', this.StoreLang),
        'query': {
          'project_id': project_id,
          'project_type': 'wanalyzer_machinelearning_query',
          'ml_id': machine_learning_id
        }
      });
    },
    f_goToUserStatisticsViewProducts: function (user_shopcart_bundle_client_id, user_shopcart_bundle_product_client_id, project_id, stats_id) {
      this.$router.push({
        'path': ClsRoute.f_getRoutePath('user_project_statistics_view', this.StoreLang),
        'query': {
          'project_id': project_id,
          'project_type': 'wanalyzer_stats_view',
          'stats_id': stats_id,
        }
      });
    },
    f_showCheckProduct: function (product_data) {
      let show_product = true;
      try {
        if (product_data.data['0']['48']['val']['value'] === '0') {
          show_product = false;
        }
      } catch(err) {}
      return show_product;
    },
    f_userShopCartBundleActiveList: function () {
      this.d_loading = true;
      let query = 'user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.user_shopcart_bundle_active_list(query, data)
        .then(resp => {
          this.d_loading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_shopOrderList = resp.data.list;
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_getEligibleBundleProductPaymentStatus: function (pay_data) {
      let pay_last_status = '';
      let pay_option_list = [];
      try {
        pay_last_status = pay_data.data['0']['0']['val']['value'];
      } catch(err) {}
      for (let option_index in this.d_usrShpcrtBundProPayWdm['0']['parameters']['0']['options']) {
        if (pay_last_status !== this.d_usrShpcrtBundProPayWdm['0']['parameters']['0']['options'][option_index].value) {
          pay_option_list.push(this.d_usrShpcrtBundProPayWdm['0']['parameters']['0']['options'][option_index]);
        }
      }
      return pay_option_list;
    },
    f_getEligibleBundleProductStatus: function (product_data) {
      let product_last_status = '';
      let product_option_list = [];
      try {
        product_last_status = product_data.data['0']['0']['val']['value'];
      } catch(err) {}
      for (let option_index in this.d_usrShpcrtBundProWdm['0']['parameters']['0']['options']) {
        if (product_last_status !== this.d_usrShpcrtBundProWdm['0']['parameters']['0']['options'][option_index].value) {
          product_option_list.push(this.d_usrShpcrtBundProWdm['0']['parameters']['0']['options'][option_index]);
        }
      }
      return product_option_list;
    },
    f_getEligibleBundleStatus: function (shopcart_bundle_data) {
      let bundle_last_status = '';
      try {
        bundle_last_status = shopcart_bundle_data.data['0']['0']['val']['value'];
      } catch(err) {}
      let bundle_option_list = [];
      for (let option_index in this.d_usrShpcrtBundWdm['0']['parameters']['0']['options']) {
        if (bundle_last_status !== this.d_usrShpcrtBundWdm['0']['parameters']['0']['options'][option_index].value) {
          bundle_option_list.push(this.d_usrShpcrtBundWdm['0']['parameters']['0']['options'][option_index]);
        }
      }
      return bundle_option_list;
    },
    f_getOptionLabel: function (option_value, options) {
      // console.log('option_value : ', option_value);
      // console.log('options : ', options);
      let option_label = '';
      for (let i in options) {
        if (options[i].value === option_value) {
          option_label = options[i].translation[this.StoreLang];
          break;
        }
      }
      return option_label;
    },
    f_openPaymentScreen: function (product_list, user_shopcart_bundle_client_id) {
      this.d_selectedProductListForPayment.product_list = product_list;
      this.d_selectedProductListForPayment.user_shopcart_bundle_client_id = user_shopcart_bundle_client_id;
      this.d_selectedProductListForPayment.show = true;
    },
    f_openProductIngredients: function (product_data) {
      this.d_selectedProductData.show = true;
      this.d_selectedProductData.data = product_data;
    },
    f_openProductPaymentIngredients: function (payment_data) {
      this.d_selectedProductPaymentData.show = true;
      this.d_selectedProductPaymentData.data = payment_data;
    },
    f_searchUserShopBundle: function (usr_shp_bund) {
      let res = false;
      if (this.d_searchText) {
        if (usr_shp_bund.w_id.toLocaleLowerCase().indexOf(this.d_searchText.toLocaleLowerCase()) !== -1) {
          res = true;
        }
      } else {
        res = true;
      }
      return res;
    },
    f_calculateProductTotalPrice: function (bundle_products) {
      let currency_text = this.StoreCurrencyType.label;
      let total_amount = 0;
      for (let product_index in bundle_products) {
        try {
          for (let currency_amount_index in bundle_products[product_index].product.data['0']['25'].list) {
            let currency_amount_item = bundle_products[product_index].product.data['0']['25'].list[currency_amount_index];
            try {
              if (currency_amount_item['26']['val']['value'] === this.StoreCurrencyType.value) {
                total_amount += parseFloat(currency_amount_item['27']['val']);
              }
            } catch(err) {}
          }
        } catch(err) {}
      }
      return total_amount + ' ' + currency_text;
    },
  },
  watch: {
    'd_showArticleModal': function () {
      if (!this.d_showArticleModal) {
        this.d_articleAdding = false;
        this.d_selectedArticleIndex = '';
        this.d_articleData = '';
        this.d_articleActive = false;
      }
    }
  }
};

</script>

<style scoped>
/* Genel Stil Tanımları */
.font-size-base {
    font-size: 16px;
}
.text-align-left {
    text-align: left;
}
.text-align-right {
    text-align: right;
}
.text-color-dark-gray {
    font-size: 15px;
    color: #334155; /* slate-700 */
}
.font-weight-bold-important {
    font-weight: 700 !important;
}

/* Aralık (Margin/Padding) Kısaltmaları */
.mb-3-75 {
    margin-bottom: 15px !important;
}
.mt-5 {
    margin-top: 20px !important;
}
.mb-2-5 {
    margin-bottom: 10px !important;
}
.mr-1-25 {
    margin-right: 5px !important;
}
.mr-2 {
    margin-right: 8px !important;
}

/* Kategor/Başlık Stilleri */
.category-tag-style {
    background-color: #e2f3ff; /* sky-100 */
    padding: 8px 15px;
    border-radius: 12px;
    font-size: 14px;
    color: #0369a1; /* sky-700 dark */
    font-weight: 600;
    text-align: left;
}
.bundle-title-box-style {
    margin-bottom: 20px;
    text-align: left;
    background: #f0f9ff; /* sky-50 */
    padding: 20px;
    border-radius: 14px;
    box-shadow: 0 4px 12px rgba(30, 64, 175, 0.1);
    font-weight: 700;
    border: 1px solid #dbe3ef; /* slate-200 */
}
.bundle-title-h2-style {
    margin: 0;
    font-size: 24px;
    color: #0f172a; /* slate-900 */
}

/* Bölüm Başlıkları (Section Headers) Stilleri */
.section-header-style {
    text-align: left;
    background-color: #e6fffa; /* teal-50 */
    border-radius: 8px;
    padding: 10px 15px;
    border-left: 5px solid #00c49a; /* teal-400/500 */
    color: #00796b; /* teal-700 */
}
.section-icon-style {
    margin-right: 8px;
}

/* Ürün Listesi Stilleri */
.product-item-row-style {
    margin: 0 0 8px 0;
    padding: 8px 15px;
    border-bottom: 1px solid #f1f5f9; /* slate-100 */
    align-items: center;
}
.product-icon-style {
    color: #00c49a; /* teal-400/500 */
    margin-right: 8px;
    font-size: 14px;
}
.price-style {
    color: #1e40af; /* indigo-700 */
    font-weight: 700;
}

/* Özellik (Feature) Listesi Stilleri */
.feature-item-row-style {
    margin: 0 0 5px 0;
    padding: 5px 15px;
    border-bottom: 1px dashed #f1f5f9; /* slate-100 */
    text-align: left;
}
.feature-highlight-icon {
    color: #00c49a; /* teal-400/500 */
    margin-right: 8px;
}
.feature-general-icon {
    font-size: 10px;
    color: #00c49a; /* teal-400/500 */
    margin-right: 8px;
}
.link-style {
    color: #1e40af; /* indigo-700 */
    font-weight: 500;
}

/* Veri Kümesi (Dataset) Stilleri */
.dataset-item-row-style {
    margin: 0 0 5px 0;
    padding: 5px 15px;
    border-bottom: 1px dashed #f1f5f9; /* slate-100 */
    text-align: left;
}
.dataset-label-style {
    font-weight: 800 !important;
    /*color: #1e40af; */
    margin-right: 8px;
}

.preview-link-box-style {
    
    border-radius: 8px;
    background-color: #f0f9ff; /* sky-50 */
    padding: 10px 15px;
    border: 1px solid #dbe3ef; /* slate-200 */
}

/* Sözleşme Önizleme Stilleri */
.agreement-link-box-style {
    text-align: right;
    border-radius: 8px;
    background-color: #f0f9ff; /* sky-50 */
    padding: 10px 15px;
    border: 1px solid #dbe3ef; /* slate-200 */
}
.agreement-link-style {
    cursor: pointer;
    color: #1e40af; /* indigo-700 */
    font-weight: 600;
}

/* Sidebar (Sağ Kolon) Stilleri */
.sidebar-box-style {
    border: 1px solid #dbe3ef; /* slate-200 */
    border-radius: 14px;
    padding: 20px;
    background: #f8fafc; /* slate-50 */
    box-shadow: 0 2px 8px rgba(30, 64, 175, 0.06);
}
.hr-style {
    border-color: #e2e8f0; /* slate-200 */
}
.hr-transparent {
    border-color: transparent;
}

/* Buton Stilleri */

/* Sepete Ekle Butonu */
.add-to-cart-button-style {
    border: none;
    color: white;
    background: linear-gradient(to bottom right, #1FA2FF, #12D8FA);
    padding: 10px 18px;
    border-radius: 12px;
    box-shadow: 0 2px 6px rgba(3, 105, 161, 0.25);
    font-weight: 700;
    transition: all 0.2s ease-in-out; /* Geçiş animasyonu ekledik */
}
.add-to-cart-button-style:hover {
    /* Hover'da rengi biraz koyulaştırarak derinlik hissi verelim */
    background: linear-gradient(to bottom right, #1091e9, #05c2e0);
    box-shadow: 0 4px 12px rgba(3, 105, 161, 0.4);
    transform: translateY(-1px); /* Hafif yukarı kaydırma efekti */
}

/* Ürün Temsilcisi Butonu */
.product-representative-button-style {
    background-color: #cbd5e1 !important; /* slate-300 */
    color: #334155 !important; /* slate-700 */
    border: none;
    border-radius: 8px;
    font-weight: 600;
    transition: all 0.2s;
}
.product-representative-button-style:hover {
    background-color: #94a3b8 !important; /* slate-400 */
    /*color: white !important;*/
    box-shadow: 0 2px 4px rgba(51, 65, 85, 0.2);
}

/* Kısa Link Oluştur Butonu */
.create-short-link-button-style {
    background-color: #94a3b8 !important; /* slate-400 */
    color: white !important;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    transition: all 0.2s;
}
.create-short-link-button-style:hover {
    background-color: #64748b !important; /* slate-500 */
    box-shadow: 0 2px 4px rgba(51, 65, 85, 0.2);
}

/* Sözleşme Önizleme Linki (span) için Hover */
.agreement-link-style {
    cursor: pointer;
    color: #1e40af; /* indigo-700 */
    font-weight: 600;
    transition: color 0.15s;
}
.agreement-link-style:hover {
    color: #3b82f6; /* blue-500 */
    text-decoration: underline;
}

.underlined-price {
  font-size: 14px;
  color: black;
  position: relative;
  display: inline-block;
  margin-left: 10px;
}

.underlined-price::after {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;           /* Metnin tam ortası */
  width: 100%;
  height: 2px;
  background: red;
  transform: rotate(-25deg) translateY(-50%);
  transform-origin: center;
  pointer-events: none;
}

</style>